"use strict";
import { Auth } from '@shared/auth';
var CompatNavigationComponent = (function () {
    function CompatNavigationComponent(auth) {
        this.auth = auth;
    }
    CompatNavigationComponent.prototype.ngOnInit = function () {
        // Note: this is a hack for allowing us to set transparent navigation
        // if the PHP template variable transparent_header is set to true.
        this.transparent = window.webappCompat.navigation.transparent;
        // HACK to force reload the current page when SwitchAccount is used. This
        // is needed of legacy pages as parts of the UI won't react to the
        // AuthState update.
        this.auth.authState.pairwise().subscribe(function (_a) {
            var previousAuth = _a[0], auth = _a[1];
            if (previousAuth && auth && previousAuth.userId !== auth.userId) {
                window.location.reload();
            }
        });
    };
    CompatNavigationComponent.ctorParameters = function () { return [{ type: Auth }]; };
    return CompatNavigationComponent;
}());
export { CompatNavigationComponent };
//# sourceMappingURL=compat-navigation.component.js.map


// WEBPACK FOOTER //
// compat-navigation.component.js